import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepSubheading = styled(Typography)(() => ({
  padding: '17px 0px 45px',
  fontSize: '0.875rem',
}));
